<template>
  <f7-page>
    <!-- Nuevo card exterior (con sombra y padding general) -->
    <div class="outer-card">
      <!-- Submenú en la parte superior del card -->
      <div class="sub-menu-wrapper">
        <SubMenu
          :items="MenuOptions.contexts.samples.itemsByArea.agronomy"
        />
      </div>
      <!-- Título principal para registrar o editar según se indique -->
      <div v-if="this.isEditingFarm" class="summary-sidebar-header">
        <span class="summary-title-text">
          {{ $t('editFarm') }}
        </span>
      </div>
      <div v-else class="summary-sidebar-header">
        <span class="summary-title-text">
          {{ $t('registerFarm') }}
        </span>
      </div>

      <div class="card-wrapper">
        <!-- Card izquierdo: Formulario -->
        <div class="info-card">
          <RegisterFarmForm />
        </div>

        <!-- Card derecho: Mapa -->
        <div class="map-card">
          <GISEditorSigpac
            :tree-locations="centroide ? true : false"
            :disabled-edit-parcel="false"
            :create-sector="centroide ? false : true"
            :zoom="15"
            @disableSaveButton="disableSaveButton"
          />
        </div>
      </div>

      <div>
        <!-- <GISEditorSigpac
        :tree-locations="centroide ? true : false"
        :disabled-edit-parcel="false"
        :create-sector="centroide ? false : true"
        :zoom="15"
        @disableSaveButton="disableSaveButton"
      />
      <RegisterFarmForm /> -->

        <f7-row class="margin-top-half">
          <f7-col style="display: flex; justify-content: flex-end">
            <DxButton
              class="standardBtn marginTop10"
              type="normal"
              styling-mode="outlined"
              :text="!isEditingFarm ? $t('next') : $t('save')"
              :disabled="saveBtnDisabled"
              @click="
                () => {
                  if (isEditingFarm) {
                    onSaveEditFarm();
                  } else {
                    nextStep();
                  }
                }
              "
            />
          </f7-col>
        </f7-row>
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import GISEditorSigpac from '@/components/Gis/EditorSigpac/index.vue';
import RegisterFarmForm from '@/components/Agronomy/AdvancedServices/RegisterFarmForm/index.vue';
import DxButton from 'devextreme-vue/button';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import MenuOptions from '@/json/menuOptions.json';
import SubMenu from '@/components/SubMenu/index.vue';

export default {
  components: {
    GISEditorSigpac,
    RegisterFarmForm,
    DxButton,
    SubMenu,
  },
  data() {
    return {
      saveBtnDisabled: false,
      MenuOptions,
    };
  },
  computed: {
    ...mapState('gisEditor', ['centroide']),
    ...mapState('registerFarm', [
      'farm',
      'accountable',
      'isEditingFarm',
      'farmStr',
    ]),
  },
  beforeMount() {
    if (this.isEditingFarm) {
      this.setCurrentRoute([
        {
          name: this.$t('Agronomy'),
          disabled: false,
          page: 'AgronomySamplesPage',
          active: false,
        },
        {
          name: this.$t('advancedServices'),
          disabled: false,
          page: 'AdvancedServicesPage',
          active: false,
        },
        {
          name: this.$t('editFarm'),
          disabled: true,
          page: 'AdvancedServicesPage',
          active: true,
        },
      ]);
    } else {
      this.setCurrentRoute([
        {
          name: this.$t('Agronomy'),
          disabled: false,
          page: 'AgronomySamplesPage',
          active: false,
        },
        {
          name: this.$t('advancedServices'),
          disabled: false,
          page: 'AdvancedServicesPage',
          active: false,
        },
        {
          name: this.$t('registerFarm'),
          disabled: true,
          page: 'AdvancedServicesPage',
          active: true,
        },
      ]);
    }

    this.setParcelIndex(0);
    this.resetParcelGeoFeature([]);
  },
  methods: {
    disableSaveButton(value) {
      this.saveBtnDisabled = value;
    },
    nextStep() {
      if (!this.farm || !this.accountable) {
        this.$notifyDX(
          {
            message: this.$t('fillRequiredFields'),
            width: 350,
          },
          'error',
          NOTIFY_TIME_LONG
        );
        return;
      }

      if (!this.centroide) {
        this.$notifyDX(
          {
            message: this.$t('Gis.mustDrawGeometry'),
            width: 350,
          },
          'error',
          NOTIFY_TIME_LONG
        );

        return;
      }

      this.setParcelArea(null);
      this.setParcelCentroide(null);

      this.$f7router.navigate(
        { name: 'AdvancedServicesParcelRegistrationPage' },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
    },
    async onSaveEditFarm() {
      try {
        if (!this.farm || !this.accountable) {
          this.$notifyDX(
            {
              message: this.$t('fillRequiredFields'),
              width: 350,
            },
            'error',
            NOTIFY_TIME_LONG
          );
          return;
        }

        if (!this.centroide) {
          this.$notifyDX(
            {
              message: this.$t('Gis.mustDrawGeometry'),
              width: 350,
            },
            'error',
            NOTIFY_TIME_LONG
          );
        }

        this.$f7.preloader.show();

        await this.updateFarmGeoFeature();

        this.$notifyDX(
          {
            message: this.$t('editFarmSuccess'),
            width: 350,
          },
          'success',
          3000
        );

        this.$f7router.navigate(
          { name: 'AdvancedServicesPage' },
          {
            animate: true,
            transition: 'f7-fade',
          }
        );
      } catch (e) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(
                JSON.parse(e.message).error
              )
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
      }
    },
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('gisEditor', [
      'setParcelArea',
      'setParcelCentroide',
      'setParcelIndex',
      'resetParcelGeoFeature',
    ]),
    ...mapActions('registerFarm', ['updateFarmGeoFeature']),
  },
};
</script>
<style scoped>
.card-wrapper {
  display: flex;
  flex-direction: row;
  gap: 24px;
  padding: 24px;
  padding-top: 18px !important;
  height: 60vh;
  background: #fff;
  border-radius: 10px;

  box-sizing: border-box;
}

/* Tarjeta de información */
.info-card {
  width: 400px;
  background: var(--Neutral-10, #f7f7f8);
  border-radius: 10px;
  padding: 0px;
  box-sizing: border-box;
  overflow-y: auto;
}

/* Tarjeta del mapa */
.map-card {
  flex-grow: 1;
  border-radius: 10px;
  overflow: hidden;
}

.sub-menu-wrapper {
  width: 100%;
}

.summary-sidebar-header {
  font-size: 20px;
  font-weight: bold;
  color: var(--Primary-Blue-60, #00346a);
  margin: 15px 0;
  padding-left: 24px;
}

.summary-title-text {
  display: inline-block;
}

/* Nuevo card exterior: sombra y padding general */
.outer-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(87, 84, 95, 0.3);
  padding: 24px;
  display: flex;
  flex-direction: column;
  padding-left: 15px;
}

.marginTop15 {
  margin-top: -20px;
}

.outer-card .card-wrapper {
  box-shadow: none;
}
</style>
